<template>
  <div class="container">
    <table></table>
    <div class="main">
      <van-field
        v-model="content"
        label="心愿内容"
        placeholder="请输入您的心愿"
      />
      <van-field
        v-model="name"
        readonly
        label="姓名"
        placeholder="请输入您的姓名"
      />
      <van-field
        v-model="mobile"
        readonly
        label="联系方式"
        placeholder="请输入您的联系方式"
      />
      <van-field
        v-model="address"
        label="联系地点"
        placeholder="请输入您的联系地点"
      />
      <van-field
        readonly
        clickable
        label="所在地区"
        v-model="street"
        :value="street"
        @click="streetshowPicker = true"
      />
      <van-popup v-model="streetshowPicker" round position="bottom">
        <van-picker
          show-toolbar
          :columns="street_columns"
          value-key="name"
          @cancel="streetshowPicker = false"
          @confirm="streetonConfirm"
          @change="streetchange"
        />
      </van-popup>
    </div>
    <div class="main fontcss">
      <van-cell-group>
        <p>备注</p>
        <van-field
          v-model="memo"
          rows="2"
          autosize
          type="textarea"
          maxlength="50"
          placeholder="请输入内容"
          show-word-limit
          style="background: #f9f9f9; border-radius: 2px"
        />
      </van-cell-group>
      <div>
        <p>上传封面图片</p>
        <van-uploader :after-read="afterRead" v-model="fileList" multiple />
      </div>
    </div>
    <van-button type="primary" block @click="apply">发布</van-button>
    <table></table>
  </div>
</template>
<script>
export default {
  name: "applywish",
  data() {
    return {
      content: "",
      name: "",
      mobile: "",
      address: "",
      memo: "",
      fileList: [],
      type: "",
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      data: { token: sessionStorage.getItem("wmtoken") },
      img: [],
      areashowPicker: false,
      streetshowPicker: false,
      street_columns: [
        {
          values: [],
          defaultIndex: 0,
          className: "column1",
        },
        {
          values: [],
          defaultIndex: 0,
          className: "column2",
        },
      ],
      area_columns: [
        {
          values: [],
          defaultIndex: 0,
          className: "column1",
        },
        {
          values: [],
          defaultIndex: 0,
          className: "column2",
        },
        {
          values: [],
          defaultIndex: 0,
          className: "column3",
        },
      ],
      areachoose: "320281",
      streetchoose: "",
      villagechoose: "",
      street: "",
      appId: "2312",
      url: "//zhuzhan.ijiangyin.com/siteapp/appClient/sign",
    };
  },
  created() {
    var that = this;
    //app
    zjyapi.init({
      appId: that.appId,
      error: function (code, ret) {
        //失败回调,默认
        alert("初始化失败");
      },
      success: function success(ret) {
        that.queryUserInfoAll();
      },
    });
    that.locate("320281").then((res) => {
      that.street_columns[0].values = res;
      that.locate(that.street_columns[0].values[0].code).then((res) => {
        that.street_columns[1].values = res;
      });
    });
  },
  methods: {
    //app相关开始
    //获取签名方法
    getSign: function (fun) {
      /*请求参数*/
      var paramObj = {
        httpUrl: this.url,
        type: "post",
        data: {
          appId: this.appId,
        },
      };
      /*请求调用*/
      this.httpRequest(paramObj, fun, function () {
        alert("获取签名失败错误");
      });
    },
    httpRequest: function (paramObj, fun, errFun) {
      var xmlhttp = null;
      /*创建XMLHttpRequest对象，
       *老版本的 Internet Explorer（IE5 和 IE6）使用 ActiveX 对象：new ActiveXObject("Microsoft.XMLHTTP")
       * */
      if (window.XMLHttpRequest) {
        xmlhttp = new XMLHttpRequest();
      } else if (window.ActiveXObject) {
        xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
      }
      /*判断是否支持请求*/
      if (xmlhttp == null) {
        alert("你的浏览器不支持XMLHttp");
        return;
      }
      /*请求方式，并且转换为大写*/
      var httpType = (paramObj.type || "GET").toUpperCase();
      /*数据类型*/
      var dataType = paramObj.dataType || "json";
      /*请求接口*/
      var httpUrl = paramObj.httpUrl || "";
      /*是否异步请求*/
      var async = paramObj.async || true;
      /*请求参数--post请求参数格式为：foo=bar&lorem=ipsum*/
      var paramData = paramObj.data || [];
      var requestData = "";
      for (var name in paramData) {
        requestData += name + "=" + paramData[name] + "&";
      }
      requestData =
        requestData == ""
          ? ""
          : requestData.substring(0, requestData.length - 1);
      console.log(requestData);
      /*请求接收*/
      xmlhttp.onreadystatechange = function () {
        if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
          /*成功回调函数*/
          //获取签名数据成功:{"serverTime":null,"error":"200","msg":"成功","data":{"appSign":"b37808616bda9d71e100e0971881101d","appId":"2312""timestamp":1575953679723},"map":null}
          console.log("获取签名数据成功:" + xmlhttp.responseText);
          var obj = JSON.parse(xmlhttp.responseText);
          var data = obj.data;
          fun({
            timestamp: data.timestamp,
            sign: data.appSign,
          });
        } else {
          /*失败回调函数*/
          errFun;
        }
      };
      /*接口连接，先判断连接类型是post还是get*/
      if (httpType == "GET") {
        xmlhttp.open("GET", httpUrl, async);
        xmlhttp.send(null);
      } else if (httpType == "POST") {
        xmlhttp.open("POST", httpUrl, async);
        //发送合适的请求头信息
        xmlhttp.setRequestHeader(
          "Content-type",
          "application/x-www-form-urlencoded"
        );
        xmlhttp.send(requestData);
      }
    },
    queryUserInfoAll: function () {
      var that = this;
      this.getSign(function (sign) {
        zjyapi.queryUserInfoAll({
          sign: sign,
          params: {
            type: "2",
          },
          success: function (ret) {
            console.log("获取用户信息成功：" + ret);
            var data = JSON.parse(ret);
            if (data.uid) {
              sessionStorage.setItem("uid", data.uid);
            } else {
              alert("请登录app");
            }
            that.mobile = data.mobile;
            that.name = data.authenticationName;
            console.log(ret);
            console.log(JSON.parse(ret));
          },
          error: function (error) {
            console.log("获取用户信息失败：" + JSON.stringify(error));
          },
        });
      });
    },
    //end
    //app相关结束
    streetonConfirm(value, index) {
      let arr = [];
      for (let i in value) {
        arr.push(value[i].name);
      }
      this.street = arr.join("/");
      this.streetshowPicker = false;
      console.log(value);
      this.streetchoose = value[0].code;
      this.villagechoose = value[1].code;
    },
    streetchange(picker, value, index) {
      this.locate(value[0].code).then((res) => {
        picker.setColumnValues(1, res);
        this.street_columns[1].defaultIndex = 0;
      });
    },
    areaonConfirm(value, index) {
      console.log(value);
      let arr = [];
      for (let i in value) {
        arr.push(value[i].name);
      }
      this.area = arr.join("/");
      this.areashowPicker = false;
      console.log(index);
      this.areachoose = value[2].code;
    },
    areachange(picker, value, index) {
      console.log(value, index);
      this.locate(value[0].code).then((res) => {
        picker.setColumnValues(1, res);
        this.area_columns[1].defaultIndex = 0;
        this.locate(picker.getValues()[1].code).then((res) => {
          picker.setColumnValues(2, res);
          this.area_columns[2].defaultIndex = 0;
        });
      });
    },
    locate(code) {
      return this.$axios({
        method: "post",
        url: "/api/common/area",
        data: this.qs.stringify({
          code: code,
        }),
      }).then((res) => {
        //console.log(res.data);
        if (res.data.code == 0) {
          return res.data.data;
        }
      });
    },
    afterRead(file) {
      console.log(file);
      if (file.file) {
        let formData = new FormData();
        formData.append("file", file.file);
        this.$axios
          .post("/api/common/upload", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              token: sessionStorage.getItem("wmtoken"),
            },
          })
          .then((res) => {
            console.log(res.data);
            console.log(this.fileList);
            this.fileList[this.fileList.length - 1].url = res.data.data.url;
          });
      } else {
        for (let i = 0; i < file.length; i++) {
          let formData = new FormData();
          formData.append("file", file[i].file);
          this.$axios
            .post("/api/common/upload", formData, {
              headers: {
                "Content-Type": "multipart/form-data",
                token: sessionStorage.getItem("wmtoken"),
              },
            })
            .then((res) => {
              console.log(res.data);
              console.log(this.fileList);
              this.fileList[this.fileList.length - (file.length - i)].url =
                res.data.data.url;
            });
        }
      }
    },
    handleRemove(file, fileList) {
      console.log(file);
      this.fileList = fileList;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleDownload(file) {
      console.log(file);
    },
    success(response, file, fileList) {
      console.log(response);
      console.log(file);
      console.log(fileList);
      this.fileList = fileList;
    },
    apply() {
      console.log(this.areachoose, this.streetchoose, this.villagechoose);
      if (this.content == "") {
        this.$toast("心愿内容未填");
        return;
      }
      if (this.name == "") {
        this.$toast("姓名未填");
        return;
      }
      if (this.mobile == "") {
        this.$toast("手机号码未填");
        return;
      }
      if (this.address == "") {
        this.$toast("地点未填");
        return;
      }
      if (!this.villagechoose) {
        this.$toast("请选择所在地区");
        return;
      }
      /* if(this.fileList.length == 0){
        this.$toast('请上传封面图片');
      } */
      this.img = [];
      console.log(this.fileList);
      for (let i in this.fileList) {
        this.img.push(this.fileList[i].url);
      }
      this.$axios({
        method: "post",
        url: "/api/task/wish",
        data: this.qs.stringify({
          content: this.content,
          name: this.name,
          mobile: this.mobile,
          address: this.address,
          memo: this.memo,
          img: this.img,
          area: this.areachoose,
          street: this.streetchoose,
          village: this.villagechoose,
          zjy_uid: sessionStorage.getItem("uid"),
        }),
      }).then((res) => {
        console.log(res.data);
        if (res.data.code == 0) {
          this.$toast("成功发布心愿");
          this.$router.push("/eventcenter");
        } else {
          this.$toast(res.data.msg);
        }
      });
    },
  },
};
</script>
<style scoped>
.container {
  min-height: 100vh;
}
.main {
  margin: 10px;
  background: white;
}
.main p {
  font-size: 14px;
  line-height: 24px;
  margin-top: 10px;
}
.van-button {
  width: 90%;
  margin: 20px auto;
  background: #1646c0;
  border: 0;
}
.upload /deep/ .el-upload--picture-card {
  width: 25vw;
  height: 25vw;
  line-height: 25vw;
}
.upload /deep/ .el-upload-list__item {
  width: 25vw;
  height: 25vw;
  line-height: 25vw;
}
.upload
  /deep/
  .el-upload-list--picture-card
  .el-upload-list__item-status-label
  i {
  font-size: 0;
}
.fontcss {
  color: #646566;
  padding: 10px 16px;
}
</style>


// WEBPACK FOOTER //
// src/components/applywish.vue